/* eslint-disable @typescript-eslint/no-explicit-any */
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Paper from '@mui/material/Paper'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React, { useEffect, useState } from 'react'

import Items from './items'
import Button from '../../../components/elements/Button'

interface Props {
  data: any
  loading: boolean
  setLoading?: (value: boolean) => void
  onSubmit: () => any
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
}

const OngoingNotice = () => (
  <div
    style={{
      textAlign: 'center',
      padding: '19px',
      marginBottom: '30px',
      border: '2px solid red',
      color: 'black',
    }}>
    Please <b>DO NOT refresh</b> the page and wait while we are processing your
    request.
  </div>
)

const Summary: React.FC<Props> = ({
  data,
  loading,
  setLoading,
  onSubmit,
  onCancel,
}) => {
  const theme = useTheme()
  const [check, setCheck] = useState(false)

  useEffect(() => {
    setLoading(false)
  }, [])

  const handleCheck = (e) => {
    if (e.target.name === 'infoCB') setCheck(e.target.checked)
  }
  return (
    <Box>
      {loading && <OngoingNotice />}
      <Paper sx={{ padding: theme.spacing(2), mb: theme.spacing(4) }}>
        <Items data={data} />{' '}
        <Typography variant="body2" my={2}>
          <Checkbox
            checked={check}
            onChange={handleCheck}
            disabled={loading}
            inputProps={{
              'aria-label': 'primary checkbox',
              name: 'infoCB',
            }}
          />
          I verify that the information above is correct.
        </Typography>
      </Paper>
      <Typography variant="subtitle2" mb={2}>
        We kindly ask you patience and understanding while we finalize the
        refund process. We respectfully request that participants refrain from
        sending individual messages at this time in order to avoid any delay.
      </Typography>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}>
        <Button secondary outlined onClick={onCancel}>
          Back
        </Button>
        <Button primary outlined onClick={onSubmit} disabled={!check}>
          Submit
        </Button>
      </Box>
    </Box>
  )
}

export default Summary
